<template>
  <v-container id="input-usage" fluid>
    <v-form @submit.prevent="checkForm">
      <v-container>
        <v-row align="center" justify="space-between">
          <v-col cols="12" md="2">
            <v-text-field
              label="Name"
              :value="value.userName"
              @input="onInput('userName', $event)"
              @focus="onFocus($event)"
            />
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field
              label="Blue"
              type="number"
              min="3"
              max="12"
              step="0.5"
              color="#40c4ff"
              :rules="rules"
              :value="value.blue"
              @input="onInput('blue', $event)"
              @focus="onFocus($event)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field
              label="Green"
              type="number"
              color="#00c853"
              min="3"
              max="12"
              step="0.5"
              :rules="rules"
              :value="value.green"
              @input="onInput('green', $event)"
              @focus="onFocus($event)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field
              label="Red"
              type="number"
              color="#ff5252"
              min="3"
              max="12"
              step="0.5"
              :rules="rules"
              :value="value.red"
              @input="onInput('red', $event)"
              @focus="onFocus($event)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field
              label="Yellow"
              type="number"
              color="yellow darken-2"
              min="3"
              max="12"
              step="0.5"
              :rules="rules"
              :value="value.yellow"
              @input="onInput('yellow', $event)"
              @focus="onFocus($event)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-row justify="space-between">
              <v-col cols="6">
                <v-btn
                  type="submit"
                  value="submit"
                  class="blue white--text"
                  :disabled="isDisabled"
                  large
                  block
                  rounded
                >Calculate</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  type="reset"
                  value="reset"
                  class="blue"
                  dark
                  @click="reset"
                  large
                  block
                  rounded
                >Reset</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <p class="hint" :class="{ 'white--text': this.isInputSumValid }">
                Sum of colour inputs must be 30, currently it is
                {{ this.inputSum }}
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ProfileInput",
  props: {
    value: Object,
  },
  data() {
    return {
      rules: [
        (value) => Number(value) >= 3 || "Input can't be less than 3",
        (value) => Number(value) <= 12 || "Input can't be larger than 12",
      ],
    };
  },
  computed: {
    inputSum: function () {
      let sum =
        (isNaN(Number(this.value.blue)) ? 0 : Number(this.value.blue)) +
        (isNaN(Number(this.value.green)) ? 0 : Number(this.value.green)) +
        (isNaN(Number(this.value.red)) ? 0 : Number(this.value.red)) +
        (isNaN(Number(this.value.yellow)) ? 0 : Number(this.value.yellow));

      return isNaN(sum) ? 0 : sum;
    },
    isInputSumValid: function () {
      if (this.inputSum == 30) {
        return true;
      } else {
        return false;
      }
    },
    areIndividualValuesValid: function () {
      if (
        Number(this.value.blue) >= 3 &&
        Number(this.value.blue) <= 12 &&
        Number(this.value.green) >= 3 &&
        Number(this.value.green) <= 12 &&
        Number(this.value.red) >= 3 &&
        Number(this.value.red) <= 12 &&
        Number(this.value.yellow) >= 3 &&
        Number(this.value.yellow) <= 12
      ) {
        return true;
      } else {
        return false;
      }
    },
    isDisabled: function () {
      return !this.areIndividualValuesValid || !this.isInputSumValid;
    },
  },
  methods: {
    onCalculate() {
      this.$store.dispatch("setUserProfile", this.convertProfile(this.value));
      this.$store.dispatch("clearExclusions");
      this.$emit("openPanels");
    },
    convertProfile(profile) {
      let temp = JSON.parse(JSON.stringify(profile));
      temp.blue = profile.blue / 0.3;
      temp.green = profile.green / 0.3;
      temp.red = profile.red / 0.3;
      temp.yellow = profile.yellow / 0.3;
      temp.name = profile.name;
      temp.unitGroup = this.value.userName
        ? this.value.userName
        : "Your Profile";
      return temp;
    },
    checkForm: function (e) {
      if (this.isInputSumValid && this.areIndividualValuesValid) {
        this.onCalculate();
      }
    },
    reset() {
      this.$emit("input", {
        username: "",
        noc: "0000",
        blue: 0,
        green: 0,
        red: 0,
        yellow: 0,
      });
    },
    onInput(property, val) {
      let temp = this.value;
      temp[property] = val;
      this.$emit("input", temp);
    },
    onFocus(event) {
      event.target.select();
    },
  },
};
</script>

<style scoped>
.hint {
  text-align: center;
  width: 100%;
  color: red;
  font-size: 0.8em;
}
</style>
